import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { Box, Button, TextField, Typography, CircularProgress, Snackbar, Alert } from '@mui/material';
import type { AlertColor } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { useNavigate } from 'react-router-dom';
import { authenticationService } from 'src/services/authentication.service';
import { get,post } from 'src/services/httpClient.service';
import jwtDecode from 'jwt-decode';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';

const LogonFranchisee = () => {
  const { showSnackbar } = useSnackbar();
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [franchiseList, setFranchisees] = React.useState([]);
  const [logoutLoading,setLogoutLoading] = useState<any>()

  const [users, setUsers] = useState<any[]>([]);
 
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_API_URL;

 
  

const [distributorId, setDistributorId] = useState<any>(null);
const [selectedFranchise, setSelectedFranchise] = useState<any>(null);

  useEffect(() => {
    const storedData = localStorage.getItem("operatorData");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setDistributorId(parsed.id);
      if(parsed.franchiseId!=null && parsed.franchiseId!="") {
        getFranchiseData(parsed.franchiseId);
      }
    }
  }, []);

  


  const { vendorId, notRequired, companyId, operatorId } = authenticationService.getVendorFranchiseIds();

  const getDistributorLCOsList = async () => {
      try {
        setLoading(true);
        let response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getByDistributorId`, {params: {distributorId: operatorId}});
        setUsers(response?.data || []);
        setTableData(response?.data);
        setFilteredData(response?.data);
  
      } catch (error: any) {
        if (error?.response?.status === 404) {
          setUsers([]);
        } else {
          showSnackbar(
            error?.message || 'Failed to fetch operators',
            'error'
          );
        }
      } finally {
        setLoading(false);
      }
    };

    const getFranchiseData = async (franchiseId) => {
        try {
          const franchiseeData = await get(`${API_URL}/api/franchisees/vendor/${vendorId}/getFranchiseeById`, { params: { id: franchiseId } });
          setSelectedFranchise(franchiseeData?.data || []);
        } catch (error) {
          console.error('Error fetching franchise data:', error);
        }
      };

  // Fetch franchise data from backend
  // const fetchFranchisees = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await get(`${API_URL}/api/operator-franchise/vendor/${vendorId}/getFranchiseByOperatorId`, {params: {operatorId: operatorId}});
  //     if (response && Array.isArray(response)) {
  //       let franchiseList = response.map(resp => { return resp['franchise'] });
  //       console.log(franchiseList)

  //       localStorage.setItem("franchiseList", JSON.stringify(franchiseList));

       
  //       setFranchisees(franchiseList);
  //       setTableData(franchiseList);
  //       setFilteredData(franchiseList);
  //     } else {   
  //       console.error("Unexpected API response:", response);
  //       setFranchisees([]);
  //       setTableData([]);
  //       setFilteredData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching franchisees:", error);
  //     setFranchisees([]);
  //     setTableData([]);
  //     setFilteredData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

//   const fetchFranchisees = async () => {
//   try {
//     setLoading(true);

//     const response = await get(
//       `${API_URL}/api/operator-franchise/vendor/${vendorId}/getFranchiseByOperatorId`,
//       { params: { operatorId } }
//     );

//     const franchiseList = Array.isArray(response)
//       ? response.map((r: any) => r.franchise)
//       : [];

//     localStorage.setItem('franchiseList', JSON.stringify(franchiseList));

//     setFranchisees(franchiseList);
//     //setTableData(franchiseList);
//     //setFilteredData(franchiseList);

//   } catch (error: any) {
//     // ✅ Handle NO FRANCHISE case
//     if (error?.response?.status === 404) {
//       setFranchisees([]);
//       setTableData([]);
//       setFilteredData([]);
//     } else {
//       showSnackbar(
//         error?.message || 'Failed to fetch franchise list',
//         'error'
//       );
//     }
//   } finally {
//     setLoading(false);
//   }
// };


  useEffect(() => {
    //fetchFranchisees();
    getDistributorLCOsList();
  }, []);

  // Search functionality (client-side)
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    
    if (!value) {
      setFilteredData(tableData);
      return;
    }

    const filtered = tableData.filter((item: any) =>
      item.operatorName?.toLowerCase().includes(value) ||
      item.regCode?.toLowerCase().includes(value) ||
      item.distributorName?.toLowerCase().includes(value) ||
      item.franchiseName?.toLowerCase().includes(value) ||
      item.company?.toLowerCase().includes(value)
      //item.city?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  // Handle LoginOn button click
  const handleLogin = (row: any) => {
    // Store selected franchise and redirect
    localStorage.setItem('selectedFranchise', JSON.stringify(selectedFranchise));
    localStorage.setItem('selectedLCO', JSON.stringify(row));
    //console.log('Selected Franchise:', row);

    // redirect to dashboard
    navigate('/ott/franchise-dashboard');
  };

  // Handle Logout button click
  const handleLogout = async () => {
    try {
      setLogoutLoading(true);
      
      // Get operator ID from authentication service or localStorage
/*       const operatorId = authenticationService.getCurrentUser()?.id || 
                        localStorage.getItem('operatorId') || 
                        'default-operator-id'; // Fallback if not available */
                        
      
      // Call your logout API
      const response = await post(`${API_URL}/api/operators/logout/${distributorId}`);
      //console.log('response',response)


      if (response?.statusCode === 200 || response?.responseStatus === 'SUCCESS') {
      showSnackbar(response.message,'success')
        
        // Clear authentication data
        authenticationService.logout();
        
        // Clear local storage
        localStorage.removeItem('selectedFranchise');
        localStorage.removeItem('selectedLCO');
        localStorage.removeItem('operatorId');
        
        // Wait a moment to show success message before redirecting
        setTimeout(() => {
          // Redirect to login page
          navigate('/login'); // Adjust the route as per your application
        }, 1000);
        
      } else {
        showSnackbar(response?.message || 'Logout failed','error')
        
      }
      
    } catch (error: any) {
      //console.error('Logout error:', error);

      showSnackbar(
        error?.response?.data?.message || 'Logout completed locally',
        'success'
      );

      authenticationService.logout();
      localStorage.removeItem('selectedFranchise');
      localStorage.removeItem('selectedLCO');
      localStorage.removeItem('operatorId');
      
      // Even if API call fails, clear local data and redirect
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } finally {
      setLogoutLoading(false);
    }
  };


  const columns = [
    { 
      field: 'operatorName', 
      headerName: 'LCO', 
      flex: 2.5,
      renderCell: (params) => (
        <div>
          <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'white' }}>
            {params.value}
          </Typography>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)" }}>
            {params.row.company}
          </Typography>
        </div>
      )
    },
    { 
      field: 'regCode', 
      headerName: 'Reg Code', 
      flex: 2,
      renderCell: (params) => (
        <Typography sx={{ color: 'white' }}>
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'distributorName', 
      headerName: 'Distributor', 
      flex: 2.5,
      renderCell: (params) => (
        <Typography sx={{ color: 'white' }}>
          {params.value}
        </Typography>
      )
    }/* ,
    { 
      field: 'franchiseeType', 
      headerName: 'Franchise Type', 
      width: 150,
      renderCell: (params) => (
        <Typography sx={{ color: 'white' }}>
          {params.value}
        </Typography>
      )
    } */,
    { 
      field: 'franchiseName', 
      headerName: 'Franchise', 
      flex: 2.5,
      renderCell: (params) => (
        <Typography sx={{ color: 'white' }}>
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            padding: '2px 8px',
            borderRadius: '12px',
            backgroundColor: params.value ? '#4caf50' : '#f44336',
            color: 'white',
            fontSize: '0.75rem',
            fontWeight: 'bold'
          }}
        >
          {params.value ? 'Active' : 'Inactive'}
        </Box>
      )
    },
    {
      field: 'loginOn',
      headerName: 'Action',
      flex: 1,
      renderCell: (params: any) => (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: '#9c27b0',
            color: 'white',
            textTransform: 'none',
            '&:hover': { backgroundColor: '#7b1fa2' },
            '&:disabled': { backgroundColor: '#cccccc' }
          }}
          onClick={() => handleLogin(params.row)}
          disabled={!params.row.status}
        >
          Logon
        </Button>
      )
    }
  ];

  return (
    <>
      <Helmet>
        <title>Select Logon LCO</title>
      </Helmet>


      {/* No results message */}

      <PageTitleWrapper>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
            Select Logon LCO
          </Typography>
          <Button
            variant="outlined"
            disabled={logoutLoading}
            sx={{
              color: 'white',
              borderColor: 'rgba(255,255,255,0.3)',
              textTransform: 'none',
              '&:hover': {
                borderColor: 'rgba(255,255,255,0.5)',
                backgroundColor: 'rgba(255,255,255,0.1)'
              },
              '&:disabled': {
                borderColor: 'rgba(255,255,255,0.2)',
                color: 'rgba(255,255,255,0.5)'
              }
            }}
            onClick={handleLogout}
          >
            {logoutLoading ? (
              <>
                <CircularProgress size={16} sx={{ color: 'white', mr: 1 }} />
                Logging out...
              </>
            ) : (
              'Logout'
            )}
          </Button>
        </Box>
      </PageTitleWrapper>

      <Box sx={{ padding: '0 20px' }}>
        {/* Search Bar */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{display:"flex",alignItems:"center", justifyContent:'center',gap:"10px"}}>
            <TextField
            label="Search"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ width: 300 }}
            InputLabelProps={{ style: { color: 'white' } }}
            InputProps={{ 
              style: { color: 'white' },
              sx: {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255,255,255,0.3)'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255,255,255,0.5)'
                }
              }
            }}
          />
        {filteredData.length === 0 && <Button
      variant="contained"
      sx={{
        mt: 2,
        mr: 2,
        backgroundColor: '#9c27b0',
        '&:hover': {
          backgroundColor: '#7b1fa2'
        }
      }}
      onClick={() => navigate('/ott/franchise-dashboard')}
    >
      Logon
    </Button>}  
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {loading && (
              <>
                <CircularProgress size={20} sx={{ color: 'white' }} />
                <Typography variant="body2" sx={{ color: 'white' }}>Loading...</Typography>
              </>
            )}
            <Typography variant="body2" sx={{ color: 'white' }}>
              {filteredData.length} LCO(s) found
            </Typography>
          </Box>
        </Box>

        {/* Table */}
        <Box sx={{ height: 'calc(100vh - 250px)', width: '100%' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress sx={{ color: 'white' }} />
            </Box>
          ) : (
            <DataGrid
              rows={filteredData || []}
              columns={columns}
              loading={loading}
              getRowId={(row) => row.id}
              pageSize={20}
              rowsPerPageOptions={[10, 20, 50]}
              disableSelectionOnClick
              sx={{
                backgroundColor: '#1e1e2d',
                color: 'white',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#6a1b9a',
                  color: 'white'
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(255,255,255,0.1)',
                  color: 'white'
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: 'rgba(255,255,255,0.08)'
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: '1px solid rgba(255,255,255,0.1)',
                  backgroundColor: '#1e1e2d',
                  color: 'white'
                },
                '& .MuiTablePagination-root': {
                  color: 'white'
                },
                '& .MuiSvgIcon-root': {
                  color: 'white'
                }
              }}
            />
          )}
        </Box>

        {/* No results message */}
        {!loading && filteredData.length === 0 && (
          <Box sx={{ 
            textAlign: 'center', 
            padding: 4, 
            backgroundColor: '#1e1e2d', 
            borderRadius: 1,
            mt: 2,
            border: '1px solid rgba(255,255,255,0.1)'
          }}>
            <Typography variant="h6" sx={{ color: 'white' }}>
              {tableData.length === 0 ? 'No LCOs available' : 'No LCOs match your search'}
            </Typography>
            {tableData.length === 0 && (
              <Button 
                variant="contained" 
                sx={{ 
                  mt: 2,
                  backgroundColor: '#9c27b0',
                  '&:hover': { backgroundColor: '#7b1fa2' }
                }}
                onClick={getDistributorLCOsList}
              >
                Retry
              </Button>
            )}
          </Box>
        )}
      </Box>

      {/* Snackbar for logout messages */}
      {/* <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar> */}
    </>
  );
};

export default LogonFranchisee;